module.exports = __webpack_public_path__ + "img/Fujian-power.4c4d49be.png";